import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  LANGUAGE_STORAGE_KEY,
  normalizeLanguageCode,
  detectSupportedBrowserLanguage,
  resolveInitialLanguage,
  applyDocumentLanguage,
} from "./languages";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import he from "./locales/he.json";
import es from "./locales/es.json";

const blissnetBrowserLanguageDetector = {
  name: "blissnetBrowser",
  lookup() {
    return detectSupportedBrowserLanguage();
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(blissnetBrowserLanguageDetector);

const initialLanguage = resolveInitialLanguage();
applyDocumentLanguage(initialLanguage);

void i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      he: { translation: he },
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "de", "he", "es"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "blissnetBrowser"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      convertDetectedLanguage: (lng: string) => {
        const normalized = normalizeLanguageCode(lng);
        return normalized ?? undefined;
      },
      caches: [],
    },
  });

export default i18n;
